<template>
    <div class="home_container">
        <header class="home_header"> 
            <div class="current_school_box">
                <van-dropdown-menu class="school_menu" active-color="#3BD3C1">
                    <van-dropdown-item @change="changeSchool" v-model="currentSchool" :options="options" />
                </van-dropdown-menu>
            </div>
            <div class="search_box">
                <van-dropdown-menu class="school_menu" active-color="#3BD3C1">
                    <van-dropdown-item :disabled='gradeDisabled' @change="changeGrade" v-model="currentGrade" :options="gradeOptions" />
                    <van-dropdown-item :disabled='classDisabled' @change="changeClass" v-model="currentClass" :options="classOptions" />
                    <van-dropdown-item @change="changeSort" v-model="searchData.sort" :options="sortOptions" />
                </van-dropdown-menu>
            </div>
        </header>
        <main>
            <div class="msg">
                <span>总：{{ studentTotal }}</span>
                <span>应：{{ joinStudentTotal }}</span>
                <span>实：{{ clockStudentTotal }}</span>
                <span>率：{{ percent }}</span>
            </div>
            <van-list>   
                <div class="list_header">
                    <div>序号</div>
                    <div>姓名</div>
                    <van-button color="#3BD3C1" round type="info" size='small' @click="changeTime">{{ currentTime }}</van-button>
                    <!-- <div class="current_time"></div> -->
                </div>
                <van-cell v-for="(item,index) in list" :key="index">
                        <template #title>
                            <div class="item">
                                <div>{{ index + 1 }}</div>
                                <div>{{ item.studentName }}</div>
                                <div>
                                    <span v-if="item.isClock == 2">√</span>
                                    <span v-else-if="item.isClock == 1"> </span>
                                    <span v-else-if="item.isClock == 0">—</span>
                                </div>
                            </div>
                        </template>
                </van-cell>
            </van-list>
        </main>
        <van-calendar color="#3BD3C1" v-model="timeShow" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate"/>
        <div class="loading" v-if="show">
            <van-loading size="0.3rem" vertical color="#3BD3C1">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import request from "../../utils/request.js";
export default {
  data() {
    return {
      show: true,
      timeShow: false, //日历
      currentSchool: "", //当前学校Id
      currentGrade: "", //当前年级
      currentClass: "", //当前班级
      school: [], //学校数组
      options: [], //学校选项
      gradeOptions: [], //年级选项
      classOptions: [], //班级选项
      sortOptions: [
        {
          text: "升序",
          value: "asc"
        },
        {
          text: "降序",
          value: "desc"
        }
      ],
      currentTime: "",//表头日期
      minDate: "",//日历
      maxDate: "",//日历
      list: [],
      getRole: JSON.parse(localStorage.getItem("campUser")) || "", //权限
      searchData: {
        sort: "desc",//排序方式
        //开始时间戳、结束时间戳
        mondayTimestamp: "",
        weekendTimestamp: ""
      },
      studentTotal:'',//总人数
      clockStudentTotal:'',//实打卡人数
      joinStudentTotal:'',//应打卡人数
      percent:'',//今日打卡率
      gradeDisabled:false,
      classDisabled:false,
    };
  },
  created() {
    let now = new Date();
    let nowDay = now.getDate(); //当前日
    let nowMonth = now.getMonth(); //当前月
    let nowYear = now.getFullYear(); //当前年
    this.minDate = new Date(nowYear, 0, 1);
    this.maxDate = new Date(nowYear, nowMonth, nowDay);
  },
  mounted() {
    if (!sessionStorage.getItem("oo-admin-schools")) {
      request({
        url: "/api/school_camp/list",
        method: "get",
        params: {
          limit: 200
        }
      }).then(response => {
        this.options = [];
        this.school = response.data;

        this.school.forEach(item => {
          let obj = {
            text: item.campName,
            value: item.campId
          };
          this.options.push(obj);
        });
        sessionStorage.removeItem("oo-admin-schools");
        sessionStorage.setItem(
          "oo-admin-schools",
          JSON.stringify(response.data)
        );
        this.currentSchool = this.school[0].campId;
        this.show = false;
      });
    } else {
      this.options = [];
      this.school = JSON.parse(sessionStorage.getItem("oo-admin-schools"));
      this.school.forEach(item => {
        let obj = {
          text: item.campName,
          value: item.campId
        };
        this.options.push(obj);
      });
      this.currentSchool = this.school[0].campId;
      this.show = false;
    }

    let now = new Date();
    let nowDay = now.getDate(); //当前日
    let nowMonth = now.getMonth() + 1; //当前月
    let nowYear = now.getFullYear(); //当前年
    this.currentTime = `${nowYear}-${
      nowMonth < 10 ? "0" + nowMonth : nowMonth
    }-${nowDay < 10 ? "0" + nowDay : nowDay}`;
    now.setHours("00");
    now.setMinutes("00");
    now.setSeconds("00");
    this.searchData.mondayTimestamp = now.getTime();
    now.setHours("23");
    now.setMinutes("59");
    now.setSeconds("59");
    this.searchData.weekendTimestamp = now.getTime();
    this.minDate = new Date(nowYear);
    this.maxDate = new Date(nowYear, nowMonth);
    this.getList();
  },
  watch: {
    currentSchool: {
      handler(newVal) {
        if (newVal) {
          request({
            url: "/api/grade/list",
            method: "get",
            params: {
              campId: this.currentSchool
            }
          }).then(response => {
            this.gradeOptions = [];
            if (response.data && response.data.length) {
              response.data.forEach(item => {
                let obj = {
                  text: item.gradeName,
                  value: item.grade
                };
                this.gradeOptions.push(obj);
              });
            }
            if(this.getRole.role == 'admin') {
                this.currentGrade = this.gradeOptions[2].value;
            } else if(this.getRole.role == 'grade') {
                this.gradeDisabled = true
                this.currentGrade = parseInt(this.getRole.grade) 
            } else if(this.getRole.role == 'class') {
                this.gradeDisabled = true
                this.currentGrade = parseInt(this.getRole.grade) 
                this.classDisabled = true
                this.currentClass = parseInt(this.getRole.classId)
            }
          });
        }
      },
      immediate: true
    },
    currentGrade: {
      handler(newVal) {
        if (newVal) {
          request({
            url: "/api/grade_class/list",
            method: "get",
            params: {
              campId: this.currentSchool
            }
          }).then(response => {
            this.classOptions = [];
            if (response.data && response.data.length) {
              response.data.forEach(item => {
                if (item.grade == this.currentGrade) {
                  if (item.list && item.list.length) {
                    item.list.forEach(v => {
                      let obj = {
                        text: v.className,
                        value: parseInt(v.className)
                      };
                      this.classOptions.push(obj);
                    });
                  }
                }
              });
            }
            if(this.getRole.role == 'admin') {
                this.currentClass = this.classOptions[0].value;
            } else if(this.getRole.role == 'grade') {
                this.gradeDisabled = true
                this.currentGrade = parseInt(this.getRole.grade);
                this.currentClass = this.classOptions[0].value;
            } else if(this.getRole.role == 'class') {
                this.gradeDisabled = true
                this.currentGrade = parseInt(this.getRole.grade) 
                this.classDisabled = true
                this.currentClass = parseInt(this.getRole.classId)
            }
            this.getList();
          });
        }
      },
      immediate:true
    }
  },
  methods: {
    getList() {
      this.show = true;
      let startTime = parseInt(this.searchData.mondayTimestamp / 1000);
      let endTime = parseInt(this.searchData.weekendTimestamp / 1000);
      if (this.currentSchool && this.currentGrade && this.currentClass) {
        request({
          url: "/api/wechat/clock/report",
          method: "get",
          params: {
            campId: this.currentSchool, //学校id
            startTime: startTime, //选择周一00:00:00时间戳
            endTime: endTime, //选择周末23:59:59时间戳
            class: this.currentClass, //几班
            grade: this.currentGrade, //几年级
            sort: this.searchData.sort, //排序方式
            type: 3
          }
        }).then(response => {
          console.log(response.data)
          this.list = [];
          let arr = response.data.list.join.concat(response.data.list.noJoin);
          arr.forEach(item => {
            let obj = {
              studentName: item.studentName,
              isClock: 0
            };
            if (item.clockLog == undefined) {
              obj.isClock = 0;
            } else {
              if (item.clockLog && item.clockLog.length) {
                item.clockLog.forEach(v => {
                  //筛选出已打卡
                  if (v.date == this.currentTime) {
                    obj.isClock = 2;
                  }
                });
              } else {
                obj.isClock = 1;
              }
            }
            this.list.push(obj);
          });
          this.studentTotal = response.data.studentTotal
          this.clockStudentTotal = response.data.clockStudentTotal
          this.joinStudentTotal = response.data.joinStudentTotal
          this.percent = response.data.percent + '%'
          this.show = false;
        });
      }
    },
    //选择学校
    changeSchool(value) {
      this.currentSchool = value;
    },
    changeGrade() {
      //   this.getList()
    },
    //选择班级
    changeClass() {
      this.getList();
    },
    //选择排序方式
    changeSort() {
      this.getList();
    },
    //打卡日历
    changeTime() {
      this.timeShow = true;
    },
    //选择日期
    onConfirm(time) {
      let now = new Date(time);
      let nowDay = now.getDate(); //当前日
      let nowMonth = now.getMonth() + 1; //当前月
      let nowYear = now.getFullYear(); //当前年
      this.currentTime = `${nowYear}-${
        nowMonth < 10 ? "0" + nowMonth : nowMonth
      }-${nowDay < 10 ? "0" + nowDay : nowDay}`;
      this.searchData.mondayTimestamp = now.getTime();
      now.setHours("23");
      now.setMinutes("59");
      now.setSeconds("59");
      this.searchData.weekendTimestamp = now.getTime();
      this.getList();
      this.timeShow = false;
    }
  }
};
</script>

<style scoped>
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f5f5f5;
  z-index: 99999;
}

.loading > .van-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.home_header {
  background-color: #3bd3c1;
  padding: 0.2rem 0.2rem 0.3rem 0.2rem;
  border-radius: 0 0 0.2rem 0.2rem;
  margin-bottom: 0.1rem;
}

.current_school_box {
  display: flex;
  align-items: center;
  /* border-bottom: 0.01rem solid #f5f5f5; */
}

.current_school_box >>> .van-ellipsis,
.search_box >>> .van-ellipsis {
  color: #ffffff;
}

.current_school_box >>> .van-dropdown-menu__title::after,
.search_box >>> .van-dropdown-menu__title::after {
  border-color: transparent transparent #ffffff #ffffff;
}

.current_school_box >>> .van-dropdown-menu__bar,
.search_box >>> .van-dropdown-menu__bar {
  box-shadow: none;
  background-color: transparent;
  border-bottom: 0.01rem dashed #ffffff;
}

.school_menu {
  width: 100%;
}

.list_header {
  padding: 0.1rem 0.16rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.list_header,
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list_header > div,
.list_header > button,
.item > div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.msg {
    height: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.16rem 0 0.16rem
}
/* .search_box >>> .van-dropdown-menu__item--disabled .van-ellipsis {
    color: #9a9a9a
} */
.search_box >>> .van-dropdown-menu__item--disabled .van-dropdown-menu__title::after {
    border-color: transparent transparent transparent transparent;
}
</style>